let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jznKJ")).then(() => parcelRequire('28UEX'));